// @ts-check
import { SAVED_FILTER_SET_VISIBILITIES } from '@linearb/linjs-common';
import { StyledDeleteConfirmation } from './DeleteConfirmation.style';
import Icon from 'components/base/Icon';
import { getFilterSetTypeText } from '../../filter-set.utils';
import { useState } from 'react';
import useEventsTracker from '../../../tracking/useEventsTracker';
import useContextActions from '../../../../../useContextActions';
import { LBButton } from '@linearb/buzz';

const DeleteConfirmation = ({ Context, filterSet, onDelete, onCancel }) => {
  const contextActions = useContextActions({ Context });
  const [isLoading, setIsLoading] = useState(false);
  const eventsTracker = useEventsTracker({ Context });

  const typeText = getFilterSetTypeText(filterSet);
  const isPublic =
    filterSet.visibility === SAVED_FILTER_SET_VISIBILITIES.PUBLIC;

  const deleteFilterSet = async () => {
    try {
      setIsLoading(true);
      await contextActions.onDeleteFilterSet(filterSet.id);
      onDelete();
      eventsTracker.onDeleteFilterSet(filterSet);
    } catch (e) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <StyledDeleteConfirmation>
      <header>
        <Icon name='Trash' size='medium' />
        Delete {typeText}
      </header>
      <main>
        Are you sure you want to permanently delete the <br />
        {typeText} <b>"{filterSet.name}"</b>? <br />
        <br />
        {isPublic && (
          <>
            <b>Note:</b> This is a public {typeText.toLowerCase()}, accessible
            to other users.
          </>
        )}
      </main>
      <footer>
        <LBButton variant='outline' onClick={onCancel}>
          Cancel
        </LBButton>
        <LBButton onClick={deleteFilterSet} disabled={isLoading}>
          Delete {typeText}
        </LBButton>
      </footer>
    </StyledDeleteConfirmation>
  );
};

export default DeleteConfirmation;
